import React from 'react'
import {Box, Text} from '../../vanilla'
import {inputClassName, toggleSwitchRecipe} from './styles.css'
import {Sprinkles} from '../../vanilla/sprinkles.css'

interface ToggleSwitchProps {
  id: string
  type: 'checkbox' | 'radio'
  value: string
  labelPosition?: 'start' | 'end'
  checked: boolean
  label?: React.ReactNode
  labelText?: string
  labelVariant?: 'text2' | 'text3' | 'text4'
  justifyContent?: Sprinkles['justifyContent']
  name: string
  onChange:() => void
  disabled?: boolean
  dataTestSelector?: string
}

export const ToggleSwitch = (props: ToggleSwitchProps) => {
  const {
    checked,
    type,
    value,
    id,
    labelPosition = 'start',
    labelText,
    labelVariant = 'text2',
    justifyContent = 'flex-start',
    label,
    name,
    onChange,
    disabled = false,
    dataTestSelector,
  } = props

  const toggleClassName = toggleSwitchRecipe({})
  const Label = () => {
    return (
      <>
        {label || (
          <Text as="label" htmlFor={id} variant={labelVariant}>
            {labelText}
          </Text>
        )}
      </>
    )
  }

  return (
    <Box
      position="relative"
      display="flex"
      alignItems="center"
      gap="16px"
      justifyContent={justifyContent}
    >
      {labelPosition === 'start' && <Label />}
      <Box
        as="input"
        id={id}
        type={type}
        name={name}
        className={inputClassName}
        checked={checked}
        disabled={disabled}
        {...(type === 'radio' ? {value: value} : {})}
        {...(dataTestSelector ? {'data-test-selector': dataTestSelector} : {})}
      />
      <Box display="block" as="span" className={toggleClassName} onClick={onChange} />
      {labelPosition === 'end' && <Label />}
    </Box>
  )
}
